const CATEGORY = {
  MEMBERSHIP: 'membership',
  PLATFORM_CREDITS: 'platform_credits',
};

export default Object.freeze({
  CATEGORY,
});
